export const formatInterval = (timeWindow: string) => {
	return  (timeWindow === 'midnight') ? timeWindow : parseInt(timeWindow.slice(0, -1)) * 60;
}
